module.exports = __webpack_public_path__ + "img/amara_avatar.844565ad.png";